<template>
  <div class="popup-form popup-know-how">
    <div class="content-form-popup noselect">
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
      </div>
      <knowledge-base-panel/>
    </div>
  </div>
</template>

<script>
import KnowledgeBasePanel from "@/components/shared/KnowledgeBase/KnowledgeBasePanel.vue";

export default {
  name: "KnowHowPopUp",
  components: { KnowledgeBasePanel },
  methods: {
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-know-how {
  width: 92% !important;
  height: 100vh !important;
  max-height: 100vh;
  overflow: hidden !important;
}

.content-form-popup {
  height: 100%;
  overflow: hidden;
  padding: 0 !important;
}

@supports (height: 100dvh) {
  .popup-know-how {
    height: 100dvh !important;
    max-height: 100dvh;
  }
}

@media screen and (max-width: 767px) {
  .popup-know-how {
    width: 100% !important;
  }
}

.header-text {
  min-height: 0 !important;
  margin: 0 !important;
}

.back-button-wrapper {
  position: absolute;
  z-index: 5;
  top: 16px;
  right: 16px;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 10px 25px rgba(16, 26, 82, 0.16);
}
</style>
